import React from "react";

function Confirmcancelorder({Close}) {
  return (
    <div className="confirm_cancel_order_popup">
      <div className="popup_inner">
        <h5>Are you sure you want to cancel return??</h5>
       
          <div className="d-flex mt-4" style={{gap:'15px', alignItems:'center'}}>
            <button className="btn_2" onClick={Close}>
                Go Back
            </button>
            <button  className="btn_1_1">
              Cancel Button
            </button>
          </div>
        
      </div>
    </div>
  );
}

export default Confirmcancelorder;
